<ip-header [label]="'catalog.image_preview.image_download_options' | transloco"></ip-header>

@if (message) {
  <div [ngClass]="['p-2', messageClass]">
    {{ message }}
  </div>
}

<div class="border-top">
  @if (isDropbox && hasDownloadInternalRole()) {
    <div
      (click)="onDownloadDropboxImage()"
      aipbHoverHighlight
      class="p-2 pl-3 flex items-center cursor-pointer border-bottom relative"
    >
      <aipb-inside-loading [loading]="dropboxDownloadLoading" diameter="25"></aipb-inside-loading>
      <mat-icon class="mr-3 text-accent">
        deployed_code
      </mat-icon>
      <div>
        <div class="font-bold">{{ 'catalog.buttons.download_from_dropbox' | transloco }}</div>
      </div>
    </div>
  }

  @if ((freeDownloadsLeft > 0 || paidDownloadsAllowed) && hasDownloadRole() && (isDropbox || canDownloadFromArchive())) {
    @for (res of resolutions; track res; let last = $last) {
      <div
        (click)="onResourceDownload(res)"
        [ngClass]="['p-2', 'pl-3', 'flex', 'items-center', 'cursor-pointer', 'border-bottom', 'relative']"
        aipbHoverHighlight
      >
        <aipb-inside-loading [loading]="downloadsLoading[res.id]" diameter="25"></aipb-inside-loading>
        <mat-icon
          class="mr-3 text-accent"
        >cloud_download
        </mat-icon>
        <div>
          <div class="font-bold mb-2">{{ res.name }}</div>
          @if (res.maxWidth) {
            <div>
              Šířka: <span class="text-gray">{{ res.maxWidth }}px</span>
            </div>
          }
          @if (res.maxHeight) {
            <div>
              Výška: <span class="text-gray">{{ res.maxHeight }}px</span>
            </div>
          }
          <div>
            Vodoznak: <span class="text-gray">{{ res.watermark ? 'Ano' : 'Ne' }}</span>
          </div>
          <div>
            Počítá se do limitu: <span class="text-gray">{{ res.limit ? 'Ano' : 'Ne' }}</span>
          </div>
        </div>
      </div>
    }
  }

  <button (click)="onDownloadImage()" [disabled]="!imageRaw" aipbHoverHighlight
          class="w-full p-2 pl-3 flex items-center border-bottom text-left">
    <mat-icon
      class="mr-3 text-accent"
    >cloud_download
    </mat-icon>
    <div>
      <div class="font-bold">{{ 'catalog.buttons.download_shown_preview' | transloco }}</div>
    </div>
  </button>
</div>

<ip-license [license]="resolutionData?.license"></ip-license>
